import { render, staticRenderFns } from "./TeacherPopup.vue?vue&type=template&id=9c0b88d8&scoped=true"
import script from "./TeacherPopup.vue?vue&type=script&lang=js"
export * from "./TeacherPopup.vue?vue&type=script&lang=js"
import style0 from "./TeacherPopup.vue?vue&type=style&index=0&id=9c0b88d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0b88d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c0b88d8')) {
      api.createRecord('9c0b88d8', component.options)
    } else {
      api.reload('9c0b88d8', component.options)
    }
    module.hot.accept("./TeacherPopup.vue?vue&type=template&id=9c0b88d8&scoped=true", function () {
      api.rerender('9c0b88d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/teacher/TeacherPopup.vue"
export default component.exports